import { filterKm220LowestPricePercent } from '../b2bPage/openEmsDamPricing';
import { isDcPort } from '../../utils/utils';
import {
  getRatedPowerKw,
  hasMinRatedPowerKw,
  isEvuaExclusiveMapMode,
  isHighPowerMapMode,
  MAP_FILTER_160_KW,
  MAP_FILTER_SLOW_MAX_KW,
} from './evuaMapFilters';

/** API / client acdc for 220-km map pins. Slow/Fast apply with + Roaming; 160+ is DC. */
export function km220AcdcForMapFilters({ filter80Kw = false, filter160KwActive = false, portFilter = 'all' } = {}) {
  if (isHighPowerMapMode(filter80Kw, filter160KwActive)) return 'dc';
  if (portFilter === 'fast') return 'dc';
  if (portFilter === 'slow') return 'ac';
  return 'all';
}

function portIsDc(port) {
  return isDcPort(port?.plugType, port?.maxPowerWt ?? port?.max_power_wt);
}

export function filterKm220PortsByAcdc(ports, acdc) {
  if (!Array.isArray(ports) || acdc === 'all') return ports;
  if (acdc === 'dc') return ports.filter(portIsDc);
  if (acdc === 'ac') return ports.filter(port => !portIsDc(port));
  return ports;
}

/**
 * 220-km pins for the homepage map.
 * Slow must hide leftover DC even before the AC request returns.
 */
export function filterKm220PortsForMap(
  ports,
  { filter80Kw = false, filter160KwActive = false, cheapestFilter = false, portFilter = 'all', nacsFilter = false } = {}
) {
  if (!Array.isArray(ports)) return ports;
  if (isEvuaExclusiveMapMode(filter80Kw, cheapestFilter, filter160KwActive)) {
    return [];
  }
  const acdc = km220AcdcForMapFilters({ filter80Kw, filter160KwActive, portFilter });
  let next = filterKm220PortsByAcdc(ports, acdc);
  if (nacsFilter) {
    next = next.filter(port => String(port?.plugType || '').toUpperCase() === 'NACS');
  }
  if (acdc === 'ac') {
    next = next.filter(port => getRatedPowerKw(port) < MAP_FILTER_SLOW_MAX_KW);
  }
  if (filter160KwActive) {
    next = next.filter(port => hasMinRatedPowerKw(port, MAP_FILTER_160_KW));
  }
  if (cheapestFilter) {
    next = filterKm220LowestPricePercent(next, filter160KwActive ? 100 / 3 : undefined);
  }
  return next;
}
